import RequestHandler from "./request-handler";
class FotavInputTableService {
    constructor() {
        this.path = "FotavInputTable";
        if (FotavInputTableService.instance) {
            return FotavInputTableService.instance;
        }
        FotavInputTableService.instance = this;
        return this;
    }
    async get() {
        return await RequestHandler.get(this.path);
    }
    async insert(data) {
        return await RequestHandler.post(this.path, data);
    }
    async update(data) {
        return RequestHandler.put(this.path, data);
    }
    async delete(id) {
        return await RequestHandler.delete(this.path, id);
    }
    async import(data) {
        return await RequestHandler.import(this.path, data);
    }
}
const instance = new FotavInputTableService();
export default instance;